import data from '../../../data/data.json';

export default function ({ props }) {
    const { page } = props;
    const { parts } = data;

    const index = parts.findIndex(p => p.slug === page);

    if (index > -1) {
        document.getElementById('bol-zelfhulptool').className = `theme-${index + 1}`;
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/app/actions/setBodyClass.js